import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ServicePackageRevisionFragmentFragment = { __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> };

export const ServicePackageRevisionFragmentFragmentDoc = gql`
    fragment ServicePackageRevisionFragment on ServicePackageRevision {
  id
  revision_number
  min_contract_term_months
  monthly_service_fee_in_cents
  onboarding_fee_in_cents
  ops_order_price_in_cents
  note
  created_at
  created_by
  allowances {
    id
    monthly_quantity
    item {
      id
      name
    }
  }
  free_checkouts {
    id
    segment
    amount
  }
}
    `;